import React from 'react';
import { useTheme } from 'styled-components';

import GenericError from '../../../components/Errors/GenericError';
import ProductListItem from '../../../components/ProductListItem';
import Icon from '../../../components/Icon';

const Results = ({ products, loading, error }) => {
  const theme = useTheme();

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-2">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return <GenericError />;
  }

  return (
    <div>
      {products && (
        <div>
          {products.map((product) => {
            return (
              <ProductListItem
                key={`product-${product.id.toString()}`}
                product={product}
                className="mb-2"
                linkTo={`/new?mode=search&i=${product.id}`}
                after={
                  <Icon
                    name="chevron-right-outline"
                    color={theme.colors.mediumGrayColor}
                    size={32}
                  />
                }
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Results;
